export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return { valid: false, message: '邮箱地址不能为空' };
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { valid: false, message: '请输入有效的邮箱地址' };
  }
  
  if (email.length > 36) {
    return { valid: false, message: '邮箱地址过长' };
  }
  
  return { valid: true };
};

export const validatePassword = (password) => {
  if (!password || typeof password !== 'string') {
    return { valid: false, message: '密码不能为空' };
  }
  
  if (password.length < 8) {
    return { valid: false, message: '密码至少需要8位' };
  }
  
  if (password.length > 20) {
    return { valid: false, message: '密码过长' };
  }
  
  return { valid: true };
};

export const validateNickname = (nickname) => {
  if (!nickname || typeof nickname !== 'string') {
    return { valid: false, message: '昵称不能为空' };
  }
  
  if (nickname.length > 28) {
    return { valid: false, message: '昵称过长' };
  }
  
  const invalidChars = /[<>"&']/;
  if (invalidChars.test(nickname)) {
    return { valid: false, message: '昵称包含非法字符' };
  }
  
  return { valid: true };
};

export const validateVerificationCode = (code) => {
  if (!code || typeof code !== 'string') {
    return { valid: false, message: '验证码不能为空' };
  }
  
  if (code.length < 4 || code.length > 8) {
    return { valid: false, message: '验证码格式不正确' };
  }
  
  if (!/^\d+$/.test(code)) {
    return { valid: false, message: '验证码必须为数字' };
  }
  
  return { valid: true };
};

export const sanitizeInput = (input) => {
  if (!input || typeof input !== 'string') {
    return '';
  }
  
  return input.replace(/[<>"&']/g, (char) => {
    const entityMap = {
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '&': '&amp;'
    };
    return entityMap[char];
  });
};

export const sanitizeHTML = (html) => {
  if (!html || typeof html !== 'string') {
    return '';
  }
  
  let sanitized = html;
  
  // 移除危险的标签和属性
  const dangerousTags = ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'link', 'meta'];
  dangerousTags.forEach(tag => {
    const regex = new RegExp(`<${tag}[^>]*>.*?</${tag}>`, 'gis');
    sanitized = sanitized.replace(regex, '');
    const selfClosingRegex = new RegExp(`<${tag}[^>]*/?>`, 'gis');
    sanitized = sanitized.replace(selfClosingRegex, '');
  });
  
  // 移除危险的事件处理器
  const dangerousEvents = [
    'on\\w+',
    // eslint-disable-next-line no-script-url
    'javascript:',
    'data:',
    'vbscript:',
    'expression\\s*\\(',
    'eval\\s*\\(',
    'setTimeout\\s*\\(',
    'setInterval\\s*\\('
  ];
  dangerousEvents.forEach(event => {
    const regex = new RegExp(event, 'gi');
    sanitized = sanitized.replace(regex, '');
  });
  
  // 移除危险的样式属性
  sanitized = sanitized.replace(/style\s*=\s*["'][^"']*["']/gi, (match) => {
    if (match.match(/expression|javascript|behavior|binding|url\s*\(/i)) {
      return '';
    }
    return match;
  });
  
  return sanitized;
};

export const validateAndSanitize = (input, validator) => {
  const validation = validator(input);
  if (!validation.valid) {
    return validation;
  }
  
  return { valid: true, sanitized: sanitizeInput(input) };
};
